import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import {ActionsBase, DispatchAll} from '@store/@types/alt';
import {
  AuthSource,
  FindLoginTypeRequest,
  LoginTypeResponse,
  LogoutParams,
  PasswordLoginRequest,
  TokenLoginParams,
} from 'stores/AuthSource';
import User from 'records/User';

interface AsyncActions {
  login: (params: PasswordLoginRequest) => Promise<User>;
  findLoginType: (params: FindLoginTypeRequest) => Promise<LoginTypeResponse>;
  tokenLogin: (params: TokenLoginParams) => Promise<User>;
  logout: (params: LogoutParams) => Promise<void>;
  getUserMeInfo: () => Promise<User>;
}

interface SyncActions {
  saveNext: (nextPathname: string) => void;
}

class AuthActions
  extends ActionsBase<AsyncActions, SyncActions>()
  implements DispatchAll<AsyncActions>
{
  constructor() {
    super();
    this.generateActions(
      ...generateAsyncActions<AsyncActions>('login', 'logout', 'getUserMeInfo'),
      'saveNext'
    );
  }

  login(params: PasswordLoginRequest) {
    return dispatch => {
      dispatch();
      return AuthSource.passwordLogin(params).then(this.loginSuccess, this.loginError);
    };
  }

  tokenLogin(params: TokenLoginParams) {
    return dispatch => {
      dispatch();
      return AuthSource.tokenLogin(params).then(this.loginSuccess, this.loginError);
    };
  }

  logout(params: LogoutParams) {
    return dispatch => {
      dispatch(params);
      return AuthSource.logout().then(this.logoutSuccess, this.logoutError);
    };
  }

  getUserMeInfo() {
    return dispatch => {
      dispatch();
      return AuthSource.getUserMeInfo().then(this.getUserMeInfoSuccess, this.getUserMeInfoError);
    };
  }

  findLoginType(params: FindLoginTypeRequest) {
    return dispatch => {
      dispatch();
      return AuthSource.findLoginType(params);
    };
  }
}

export default alt.createActions<AsyncActions, SyncActions>(AuthActions);
